import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const KickoffIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 1a1 1 0 0 0-1 1v1h-.5a3.5 3.5 0 1 0 0 7h.6A7 7 0 0 0 9 15.3V17l-.4.3c-1.3.6-2.3 2-2.5 3.7H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2h-2c-.3-1.6-1.3-3-2.6-3.7a1 1 0 0 1-.4-.2v-1.8a7 7 0 0 0 4-5.3h.5a3.5 3.5 0 0 0 0-7H19V2c0-.6-.4-1-1-1H6Zm13 4v3h.5a1.5 1.5 0 0 0 0-3H19Zm-6 11a7 7 0 0 1-2 0v1c0 1.2-1 1.8-1.6 2.1-.5.3-1 1-1.3 1.9H16c-.2-1-.8-1.6-1.3-1.9-.7-.3-1.6-1-1.6-2.1v-1ZM5 8V5h-.5a1.5 1.5 0 0 0 0 3H5Zm2 1V3h10v6A5 5 0 1 1 7 9Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default KickoffIcon;
